import { FC, useState } from 'react';
import { IModal } from '@epam/uui-core';
import {
  Button,
  FlexRow,
  ModalBlocker,
  ModalHeader,
  ModalWindow,
  Panel,
  Text,
  TextInput,
} from '@epam/promo';
import { RulesHint } from '../UserGroupEditModal/RulesHint';
import css from '../UserGroupEditModal/UserGroupEditModal.module.scss';

export interface IUserGroupAddModal {
  onConfirm: (groupName: string, rolesList: string) => void;
  modalProps: IModal<void>;
}

export const UserGroupAddModal: FC<IUserGroupAddModal> = ({
  onConfirm,
  modalProps,
}) => {
  const [groupName, setGroupName] = useState('');
  const [rolesList, setRolesList] = useState('');

  const handleConfirm = () => {
    onConfirm(groupName, rolesList);
    modalProps.abort();
  };

  return (
    <ModalBlocker
      key={modalProps.key}
      abort={modalProps.abort}
      isActive={modalProps.isActive}
      success={modalProps.abort}
      zIndex={modalProps.zIndex}>
      <ModalWindow width="420">
        <Panel background="white">
          <ModalHeader
            borderBottom
            title="Add Group"
            onClose={modalProps.abort}
          />
          <Panel cx={css.modalBody}>
            <Text cx={css.inputTitle}>Group name</Text>
            <TextInput
              placeholder="Enter group name"
              value={groupName}
              onValueChange={(val) => setGroupName(val ?? '')}
            />
            <Text cx={css.inputTitle}>Roles name</Text>
            <TextInput
              placeholder="Enter roles names"
              value={rolesList}
              onValueChange={(val) => setRolesList(val ?? '')}
            />
            <RulesHint />
            <FlexRow cx={css.modalActions}>
              <Button
                caption="Add Group"
                color="blue"
                isDisabled={!groupName.trim()}
                onClick={handleConfirm}
              />
              <Button
                caption="Cancel"
                color="gray"
                fill="solid"
                onClick={modalProps.abort}
              />
            </FlexRow>
          </Panel>
        </Panel>
      </ModalWindow>
    </ModalBlocker>
  );
};
